import React, { useState } from "react";
import Styles from "./ContractCalculator.module.css";
import SelectionContainer from "./SelectionContainer";
import ContractViewContainer from "./ContractViewContainer";
import AggregateViewContainer from "./AggregateViewContainer";

const ContractCalculator = () => {
  const [selectedView, setSelectedView] = useState("aggregate");
  // null | 'aggregate' | <contractId>

  const isAggregateActive = selectedView === "aggregate";
  const selectedContractId = isAggregateActive ? null : selectedView;

  return (
    <div className={Styles.ContractCalculatorMain}>
      <div className={Styles.contract_main_SelectionContainer}>
        <SelectionContainer
          onSelect={(id) => setSelectedView(id)}
          selectedId={selectedContractId}
          isAggregateActive={isAggregateActive}
          onSelectAggregate={() => setSelectedView("aggregate")}
        />
      </div>
      <div className={Styles.contract_main_ContractViewContainer}>
        {isAggregateActive ? (
          <AggregateViewContainer />
        ) : (
          <ContractViewContainer contractId={selectedContractId} />
        )}
      </div>
    </div>
  );
};

export default ContractCalculator;
